import { Box, BoxProps } from '@mui/material';
import React from 'react';

import { DEFAULT_MARGIN_NORMAL } from '../../../Spacer/Spacer';

export interface Props extends Omit<BoxProps, 'columnGap' | 'rowGap' | 'gap'> {
  /**
   Gap between columns

   @default 18px/48px
   */
  columnGap?: BoxProps['columnGap'];

  /**
   * Gap between rows in the column
   *
   * @default 48px/48px
   */
  rowGap?: BoxProps['rowGap'];

  /**
   * Column Count
   *
   * @default 12
   *
   */
  columnCount?: number | 'auto-fit' | 'auto-fill';
}

const DEFAULT_COLUMN_COUNT = 12;

/**
 * Grid Container, containing one or more GridItems
 *
 * @parent Container | GridItem
 * @children GridItem
 *
 * @constructor
 */
export const FinalGridContainer: React.FC<Props> = ({
  children,
  rowGap = DEFAULT_MARGIN_NORMAL,
  columnGap = DEFAULT_MARGIN_NORMAL,
  columnCount = DEFAULT_COLUMN_COUNT,
  ...rest
}) => {
  return (
    <Box
      display="grid"
      gridTemplateColumns={`repeat(${columnCount}, 1fr)`}
      rowGap={rowGap}
      columnGap={columnGap}
      {...rest}
    >
      {children}
    </Box>
  );
};
